const COLORS = ['#00e400', '#ffff00', '#ff7e00', '#ff0000', '#99004c', '#7e0023']
// const POLLUTANT_COLORS = ['#00ff00', '#c0ff3e', '#ffff00', '#ff8000', '#ff0000', '#9933fa', '#551a8b']

const buildLevels = levels => COLORS.map((color, index) => ({
  max: levels[index],
  color
}))

const AQI_LEVELS = buildLevels([50, 100, 150, 200, 300, 500])
const LAST_AQI_LEVEL = AQI_LEVELS[AQI_LEVELS.length - 1]

const PM25_LEVELS = buildLevels([35, 75, 115, 150, 250, 500])
const PM10_LEVELS = buildLevels([50, 150, 250, 350, 420, 600])
const O3_LEVELS = buildLevels([160, 200, 300, 400, 800, 1200])
const NO2_LEVELS = buildLevels([100, 200, 700, 1200, 2340, 3840])
const SO2_LEVELS = buildLevels([150, 500, 650, 800, 1600, 2620])
const CO_LEVELS = buildLevels([5, 10, 35, 60, 90, 150])

const getPercentage = (value, {max}) => Number(((Math.min(value, max) / max) * 100).toFixed(2))

const getPercentageColor = (levels, value, lastLevel = levels[levels.length - 1]) => ({
  percentage: getPercentage(value, lastLevel),
  color: (levels.find(level => value <= level.max) || lastLevel).color
})

export default class AreaAQI {
  static PM25 = {
    name: 'PM₂.₅',
    unit: 'μg/m³'
  }
  static PM10 = {
    name: 'PM₁₀',
    unit: 'μg/m³'
  }
  static O3 = {
    name: 'O₃',
    unit: 'μg/m³'
  }
  static NO2 = {
    name: 'NO₂',
    unit: 'μg/m³'
  }
  static SO2 = {
    name: 'SO₂',
    unit: 'μg/m³'
  }
  static CO = {
    name: 'CO',
    unit: 'mg/m³'
  }

  areaId
  areaName
  dataTime
  aqi
  aqiPercentage
  level
  levelName
  aqiColor
  primary
  primaryValue
  primaryUnit
  values = []
  windLevel
  windDir
  temperature
  humidity
  pressure

  /**
   * 构造函数
   * @param areaId        区域ID
   * @param areaName      区域名称
   * @param dataTime      数据时间
   * @param aqi           AQI指数
   * @param level         AQI等级
   * @param levelName     AQI等级名称
   * @param primary       首要污染物名称
   * @param primaryValue  首要污染物浓度值
   * @param pm25Value     PM2.5浓度值
   * @param pm10Value     PM10浓度值
   * @param o3Value       O3浓度值
   * @param no2Value      NO2浓度值
   * @param so2Value      SO2浓度值
   * @param coValue       CO浓度值
   * @param windLevel     风速等级
   * @param windDir       风向
   * @param temperature   温度
   * @param humidity      湿度
   * @param pressure      气压
   */
  constructor (
    areaId,
    areaName,
    dataTime,
    aqi,
    level,
    levelName,
    primary,
    primaryValue,
    pm25Value,
    pm10Value,
    o3Value,
    no2Value,
    so2Value,
    coValue,
    windLevel,
    windDir,
    temperature,
    humidity,
    pressure
  ) {
    this.areaId = areaId
    this.areaName = areaName
    this.dataTime = new Date(dataTime)
    this.aqi = aqi
    this.aqiPercentage = getPercentage(aqi, LAST_AQI_LEVEL)
    this.level = level
    this.levelName = levelName
    this.aqiColor = (AQI_LEVELS[level - 1] || {color: '#C0C4CC'}).color
    this.primary = primary
    this.primaryValue = primaryValue
    this.primaryUnit = (Object.values(AreaAQI).find(pollutantConfig => pollutantConfig.name === primary) || {unit: ''}).unit

    this.values.push({
      ...AreaAQI.PM25,
      value: pm25Value,
      ...getPercentageColor(PM25_LEVELS, pm25Value)
    }, {
      ...AreaAQI.PM10,
      value: pm10Value,
      ...getPercentageColor(PM10_LEVELS, pm10Value)
    }, {
      ...AreaAQI.O3,
      value: o3Value,
      ...getPercentageColor(O3_LEVELS, o3Value)
    }, {
      ...AreaAQI.NO2,
      value: no2Value,
      ...getPercentageColor(NO2_LEVELS, no2Value)
    }, {
      ...AreaAQI.SO2,
      value: so2Value,
      ...getPercentageColor(SO2_LEVELS, so2Value)
    }, {
      ...AreaAQI.CO,
      value: coValue,
      ...getPercentageColor(CO_LEVELS, coValue)
    })

    this.windLevel = windLevel
    this.windDir = windDir
    this.temperature = temperature
    this.humidity = humidity
    this.pressure = pressure
  }
}



// WEBPACK FOOTER //
// ./src/views/01Data-Overview/AreaAQI.js